<template>
    <div class="attivita-riepilogo-cp-container" :class="classRiepilogoCp">
        <template v-if="riepilogo">
            <msp-tabella-records 
                :data="riepilogo"
                @select-row="selectRow"
                >
            </msp-tabella-records>
        </template>
    </div>
</template>

<script>
// TODO: confrontare CP Oggi con i record fino al giorno precedente
import { configBest } from "@src/js/vue/mixins/record-segmenti.js";
import  {_api, URLparams} from "@src/js/msp/api.js";
import { getConfig } from '@shared/config/runtime.js';
import _recordSegmenti from "@cached/record_segmento.json";
import _record from "@src/js/vue/mixins/record-segmenti.js";
import RP from "@cached/record_periodo.json";
import MspTabellaRecords from "./MspTabellaRecords.vue";

const component = {
    components: {
        MspTabellaRecords,
    },
  props: [
      "attivita_id",
      "token",
  ],
  computed: {
        classRiepilogoCp: function () {
            let selected = this.selectRiepilogoCp.options.find(
                (el)=>{
                    return el.id === this.selectRiepilogoCp.selected;
                });
            if (!selected) return "";
            return selected.class;
        },
  },
  mixins: [
  ],
  data: function() {
    return {
        riepilogo: null,
        segmenti: _recordSegmenti,
        selectRiepilogoCp: {
            selected: 3,
            options: [
                {
                    id: 0,
                    label: 'Best 3 Mesi',
                    class: 'best',
                },
                {
                    id: 1,
                    label: 'Best Anno',
                    class: 'best-anno',
                },
                {
                    id: 2,
                    label: 'Best All Time',
                    class: 'best-all-time',
                },
                {
                    id: 3,
                    label: 'Tutti',
                    class: 'tutti',
                },
            ]
        },
    }
  },
  watch: {
      attivita_id: function () {
          this.init();
      },
  },
  mounted: function() {
      this.init();
  },
  methods: {
      configBest: function (best) {

          return configBest[best.posizione - 1];
      },

      classData: function (row, index) {
          const cell = row.cells[index];
          const best = this.getBest(row);
          let className = cell.classeCol + " arp-data"; 

          if (best) {
              className += " arp-data--best";
          }

          return className;
      },

      styleData: function (row, index) {
          const cell = row.cells[index];
          const best = this.getBest(row);

          const styles = [];

          if (best) {
              const periodo = this.periodoBest(best);
              if (periodo.codice === cell.key) {
                  const config = this.configBest(best);

                  styles.push(`--color-best:${config.color}`);

              }
          }

          return styles.join(";");
      },

      selectRow: function (row) {
          this.$emit('select-row', row);
      },
      periodoBest: function (best) {
          const rp = RP.find(el=>el.id == best.rp_id);
          return rp;
      },

      getBest: function (row) {
          if (!(this.riepilogo && this.riepilogo.bests && this.riepilogo.bests.length)) {

              return null;
          }

          return this.riepilogo.bests.find(el=>el.rs_id == row.segmento.id);
      },
      renderBest: function (row, index) {
          void(index);
          const best = this.getBest(row);
          if (!best) {
              return "";
          }

          // best all time
          const config = _record.configBest;
          const color = config[best.posizione-1].color;
          const style = `--color: ${color}`;
          return `<i style='${style}' class='icon-best msp-icon-award' />`;
      },

      classHeader: function (header) {
          return `arp-head ${header.classeCol} ${header.classeHead}`;
      },

      init: function() {
          this.loadTabella();
      },
      makeRiepilogo: function (data) {
          const riepilogo = {
              ...data,
          };
          return riepilogo;
      },
      loadTabella: function () {
          if (!this.attivita_id) {
              return;
          }
          let data = {
              riepilogo_cp: 1,
              id: this.attivita_id,
          }
          let params = URLparams(data);
          let url = getConfig().api_base_url+`/api/v2/attivita.php?${params}`;

          return new Promise((resolve,reject)=>{
              _api(url,'get',null,this.token)
                  .then((result)=>{

                      if (result.success) {
                          this.riepilogo = this.makeRiepilogo(result.data);
                          this.$emit('rows-loaded', result.data.rows || []);
                          resolve(result.data);
                      } else {
                          this.listaSegmenti = [];
                          resolve(null);
                      }
                  })
                  .catch((error)=>{
                      reject(error);
                  })
          });
      },
  },
}
export default component;
</script>

